// Translations come back in no fixed order (editing recreates them), so pick
// them by locale instead of by index. The dashboard shows Arabic names first.
const byLocale = (list, locale) =>
  (Array.isArray(list) ? list : []).find(
    (t) => (t?.locale || t?.local) === locale
  );

export const productTr = (product, locale) =>
  byLocale(product?.product_translations, locale);

export const categoryTr = (category, locale) =>
  byLocale(category?.category_translations, locale);

export const productName = (product) =>
  productTr(product, "ar")?.nameProduct ||
  productTr(product, "en")?.nameProduct ||
  product?.product_translations?.[0]?.nameProduct ||
  "";

export const categoryName = (category) =>
  categoryTr(category, "ar")?.name ||
  categoryTr(category, "en")?.name ||
  category?.category_translations?.[0]?.name ||
  "";

// true when any of the values (e.g. the Arabic and English names) contains
// the search text
export const anyIncludes = (values, search) =>
  (values || []).some((value) => String(value || "").includes(search));
